import {fromJS, Map, List, Range, isList, isMap} from 'immutable';
import storage from '@synergycms_core/utils/storage';
import {is, pluck, values, keys, toLower} from 'ramda';
import {set, get} from '@synergycms_core/utils';
import {apiGetter} from '@synergycms_core/utils/api';
import actions from '../../actions';


const reservationError = (error, dispatch) => {
    if (error.name === 409) {
        dispatch(actions.notifications.send('error', error.message));
    } else if (error.message !== 'Promotion code not applicable') {
        dispatch(actions.notifications.send('error', '_%error al procesar su reserva, por favor, vuelva a intentarlo%_'));
    }

    return Promise.reject(error);
};

const compareReservationRequest = (rawRequest, currentReservationRequest) => {
    const countBono = rawRequest.reduce((acc, selection) => {
        return acc + selection.get("count");
    }, 0);

    if (countBono !== currentReservationRequest.get("blocks").count()) {
        return false;
    }
    const groupBlocks = currentReservationRequest.get("blocks").groupBy(block => block.get("id"));

    return !rawRequest.find((selection) => {
        return selection.get("count") > 0 && selection.get("count") !== groupBlocks.get(selection.get("id"), List()).count();
    });
};

const generateReservationRequest = (rawRequest, giftVoucherList) => {
    let idx = 0;
    let resRequest = Map({
        customer: Map({
            name: "",
            surname: "",
            email: "",
            phone: "",
            country: "",
            GDPR_accepted: false,
            required_policies: false,
            referer_code: ""
        }),
        blocks: fromJS(rawRequest).reduce((acc, selectedGift) => {
            const giftVoucher = giftVoucherList.get(selectedGift.get("id"));
            return acc.concat(Range(0, selectedGift.get("count")).map((count) => {
                return Map({idx: idx++, notes: ""}).merge(giftVoucher);
            }))
        }, List())
    });

    return resRequest
};

export default {
    UPDATE: (model, inputList,
             {
                 paymentToken = false,
                 merchantTransactionId = false,
                 payed = false,
                 tpvId = false,
                 tpvCode = false,
                 EPGnRetry = false,
                 blockIdx = null
             } = {}) => {
        return (dispatch, getState) => {
            const store = getState();
            /**
             * pendents:
             *
             * travel_reason?
             */
            const reservation = store.getIn(['customer', 'reservation_request']);

            let modelList;
            if (is(Array, model)) {
                modelList = model;
            } else if (model) {
                modelList = [model];
            } else {
                modelList = pluck('model')(values(inputList));
            }

            const mapList = {
                /**
                 * CUSTOMER FORM
                 */
                name: {
                    path: ['customer', 'name']
                },
                surname: {
                    path: ['customer', 'surname']
                },
                email: {
                    path: ['customer', 'email']
                },
                repeatEmail: {
                    path: ['customer', 'repeatEmail']
                },
                phone: {
                    path: ['customer', 'phone']
                },
                country: {
                    path: ['customer', 'country'],
                    callback: (InputList, key) => InputList[key].value.get('alpha2')
                },
                GDPR_accepted: {
                    path: ['customer', 'GDPR_accepted']
                },
                required_policies: {
                    path: ['customer', 'required_policies']
                },
                country_iso_code: {
                    path: ['customer', 'country_iso_code']
                },
                address: {
                    path: ['customer', 'address']
                },
                city: {
                    path: ['customer', 'city']
                },
                postal_code: {
                    path: ['customer', 'postal_code']
                },
                region: {
                    path: ['customer', 'region']
                },
                name_addressee: {
                    path: ['customer', 'name_addressee']
                },
                surname_addressee: {
                    path: ['customer', 'surname_addressee']
                },
                email_addressee: {
                    path: ['customer', 'email_addressee']
                },
                receiver: {
                    path: ['customer', 'receiver']
                },
                source_url: {
                    path: ['customer', 'source_url'],
                    defaultValue: window.location.href
                },
                gift_voucher: {
                    path: ['blocks'],
                    callback: (inputList, idx) => {
                        const value = inputList[blockIdx].value;
                        return reservation.get("blocks").setIn([blockIdx, "notes"], value).toJS();
                    }
                },
                payment: {
                    path: ['payment'],
                    callback: inputList => {
                        //const payFormCode = inputList['payForm'].value.get('code');
                        const payFormCode = 'op';
                        let paymentBody = {
                            payform_code: payFormCode,
                            amount_pending: payed ? 0 : reservation.get('price'),
                            state: payed ? 'payed' : 'pending',
                            token: paymentToken
                        };
                        if (reservation.getIn(['payment', 'amount_promo_paid'])) {
                            paymentBody = Object.assign(paymentBody, {
                                amount_promo_paid: reservation.getIn(['payment', 'amount_promo_paid'])
                            });
                        }
                        if (reservation.get('status') !== 'confirmed' && !payed) {
                            // evitem que per un error es setegi una reserva pagada a zero
                            paymentBody = Object.assign(paymentBody, {
                                amount_paid: payed ? reservation.get('price') : 0
                            });
                        }
                        if (tpvId) {
                            paymentBody = Object.assign(paymentBody, {tpv_id: tpvId});
                        }
                        if (tpvCode) {
                            paymentBody = Object.assign(paymentBody, {tpv_code: tpvCode});
                        }
                        if (EPGnRetry) {
                            paymentBody = Object.assign(paymentBody, {n_retry: EPGnRetry});
                        }
                        if (merchantTransactionId) {
                            paymentBody = Object.assign(paymentBody, {merchant_transaction_id: merchantTransactionId});
                        }

                        return paymentBody;
                    }
                },
            };



            let reservationObj = modelList.reduce((reservations, model) => {
                const key = is(Object, model) ? keys(model)[0] : model;
                const mapObj = mapList[key];
                const path = (mapObj && mapObj.path) || key;

                let value;
                if (is(Object, model) && model[key]) {
                    value = model[key];
                } else if (mapObj && (mapObj.defaultValue || mapObj.callback)) {
                    value = mapObj.defaultValue || mapObj.callback(inputList, key);
                } else if (inputList && inputList[key]) {
                    value = get('value', inputList[key]);
                }
                return set(path, value, reservations);
            }, {});

            let newReservation = fromJS(reservationObj).reduce((reduction, val, key) => {
                if (isList(val)) {
                    return reduction.set(key, val);
                } else if (isMap(val)) {
                    let mergeValue = reduction.get(key) ? reduction.get(key).mergeDeep(val) : val;
                    return reduction.set(key, mergeValue);
                } else {
                    return reduction.set(key, val);
                }
            }, reservation);

            newReservation = newReservation.setIn(['customer', 'lang_code'], toLower(store.getIn(['customer', 'lang_info', 'code'])));
            newReservation = newReservation.setIn(['customer', 'referer_code'], store.getIn(['customer', 'params', 'params', 'referer_code'], null));

            storage.set("gift_voucher_reservation", newReservation.toJS());

            return newReservation;
        };
    },
    POST_ASYNC: () => {
        return (dispatch, getState) => {
            const mgmtGroupId = getState().getIn(['customer', 'current_management_group', 'id'], false);
            const hotelId = getState().getIn(['customer', 'current_hotel', 'id'], false);
            const reservationRequest = getState().getIn(['customer', 'reservation_request']);
            return apiGetter(mgmtGroupId ? "management_groups" : undefined)
                .post('gift_voucher_cms', reservationRequest.toJS(), mgmtGroupId ? mgmtGroupId : hotelId)
                .then(response => {
                    if (response.success !== false) {
                        storage.set("gift_voucher_reservation_confirmation", response.promotion_codes);
                        storage.set("gift_voucher_reservation_merchant_tid", response.tracking_id);
                        //storage.set("gift_voucher_reservation", null);
                        reservationRequest.set('response', fromJS(response));
                        return reservationRequest;
                    } else {
                        return reservationError(Error('reservation error'), dispatch);
                    }
                })
                .catch(error => {
                    return reservationError(error, dispatch);
                });
        }
    },
    CREATE: () => {
        return (dispatch, getState) => {
            const rawRequest = getState().getIn(["customer", "raw_request"]);
            let reservationRequest = fromJS(storage.get("gift_voucher_reservation"));
            let equalsReservationRequest = true;
            if (reservationRequest) {
                equalsReservationRequest = compareReservationRequest(rawRequest, reservationRequest);
            }
            if (!reservationRequest || !equalsReservationRequest) {
                const giftVoucherList = getState().get("gift_voucher");
                reservationRequest = generateReservationRequest(rawRequest, giftVoucherList);
                storage.set("gift_voucher_reservation", reservationRequest.toJS());
                storage.unset("gift_voucher_reservation_confirmation");
            }
            return reservationRequest;
        };
    }
};


/*{
  customer : {
    "name":"test",
    "surname":"test",
    "email":"smagarino@igmweb.com",
    "phone":"dfasdfa",
    country:""
  },
  blocks : [{
    "notes":"prova3",
    "group_voucher": "BONO_REGALO",
    id: 12,
    count : 2
  },{
    "notes":"prova3",
    "group_voucher": "BONO_REGALO",
    id: 12,
    count : 2
  }]
}*/

/*{
  customer : {
    "name":"test",
    "surname":"test",
    "email":"smagarino@igmweb.com",
    "phone":"dfasdfa",
    country:""
  },
  gift_voucher : [{
    "notes":"prova3",
    "group_voucher": "BONO_REGALO",
    id: 12,
    count : 2,
    price : 123,
    title : "test",
    name : "test :D",
  },{
    "notes":"prova3",
    "group_voucher": "BONO_REGALO",
    id: 12,
    count : 2,
    price : 123,
    title : "test",
    name : "test :D",
  }]
}*/

